export { default as DimensionsSolidIcon } from './DimensionsSolidIcon';
